import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock'
import { Flex, type FlexProps, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Icon, TextDate } from '@flecto/ui'

import type { ScheduleBooking } from '../../types/ScheduleBooking'

type CellOperationProps = FlexProps & {
  booking: ScheduleBooking
}

export function CellOperation({ booking, ...props }: CellOperationProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'schedule' })
  const { operation } = booking

  return (
    <Flex {...props} direction='column' gap='xs'>
      <Text size='sm'>{operation === 'start' ? t('pickup') : t('return')}</Text>
      <Flex gap='xs' align='center'>
        <Icon icon={faClock} color='dimmed' size='sm' />
        <TextDate
          date={operation === 'start' ? booking.start_at : booking.end_at}
          variant='time-brief'
          fw='bold'
        />
      </Flex>
    </Flex>
  )
}
